import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import { smallScreen } from '../../../../../common/mixins';

const rules = () => ({
  width: '27px', // set max width for volume icons to prevent flickering
  extend: [
    smallScreen({
      width: '22px',
    }),
  ],
});

const VolumeIconContainer = ({ children }) => {
  const { css } = useFela();

  return (
    <div className={css(rules)}>
      {children}
    </div>
  );
};

VolumeIconContainer.propTypes = {
  children: PropTypes.node,
};

export default React.memo(VolumeIconContainer);
